import PropTypes from 'prop-types';
import React from 'react';

function Linkedin({ fill = '#fff', height = 16, width = 16 }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        fill={fill}
        d="M20.448 20.448h-3.556V14.88c0-1.327-.024-3.037-1.85-3.037-1.852 0-2.135 1.447-2.135 2.94v5.666H9.35V8.996h3.413v1.565h.048a3.741 3.741 0 013.368-1.85c3.605 0 4.27 2.37 4.27 5.455l-.002 6.282zM5.338 7.431a2.064 2.064 0 110-4.128 2.064 2.064 0 010 4.128zm1.778 13.018h-3.56V8.996h3.56v11.453zM22.221 0H1.77A1.751 1.751 0 00-.001 1.73v20.536a1.753 1.753 0 001.77 1.732h20.452a1.756 1.756 0 001.777-1.732V1.729A1.755 1.755 0 0022.221 0"
      ></path>
    </svg>
  );
}

Linkedin.propTypes = {
  fill: PropTypes.string,
  height: PropTypes.number,
  width: PropTypes.number
};

export default Linkedin;
